import { Button, Form, Input } from 'antd'
import axios from 'axios'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { LoginLanguageSelect } from '../../Components'
import EnglishLanguage from '../../Languages/EnglishLanguage.json'
import NlLanguage from '../../Languages/NetherlandsLanguage.json'
import EgyptLanguage from '../../Languages/EgyptLanguage.json'
import { loginUser, removeUser } from '../../Redux/actions/authActions'
import CitydealsLogo from "../../assets/CitydealsLogo.png"
import { AUTH } from '../../utils/apis'
import { allPaths } from '../../utils/constants'
import { assignLanguage, assignMessage, errorMessage, warningMessage } from '../../utils/helpers'

const Login = (props) => {
  const { history, } = props
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const path = history?.location?.pathname
  const language = useSelector(state => state?.languageReducer)
  const selectedLanguage = assignLanguage(language?.language)
  const isEnglish = language?.language === 'english'

  const onFinish = (values) => {
    values.userType = path === allPaths?.BU_LOGIN ? 'business' : 'guest'
    const { history } = props
    setLoading(true)
    axios.post(AUTH.LOGIN, values)
      .then((res) => {
        const { data } = res
        setLoading(false)
        if (data.success) {
          // successNotification(selectedLanguage?.SuccessfullyLoggedIn)
          dispatch(loginUser(data.user))
          return setTimeout(() => {
            if (data.user?.subscription?._id && data.user?.userType === "business") {
              let expiry = moment(data.user?.subscription?.expiry).utcOffset(0, true)
              let current = moment()
              let daysLeft = expiry.diff(current, 'days')
              if (daysLeft < 14) {
                warningMessage(`${daysLeft} ${selectedLanguage?.warningMessage_daysLeftForSubscription}`)
              }
            }
            history?.replace(allPaths?.HOME)
          }, 300)
        }
        errorMessage(assignMessage(data?.message, language?.language))
      })
      .catch((e) => {
        setLoading(false)
        errorMessage(assignMessage(e?.message, language?.language))
      })
  }

  useEffect(() => {
    dispatch(removeUser())
  }, [])

  return (
    <div style={{ height: '100%', background: '#FBFBFB' }}>
      <LoginLanguageSelect />
      <div className='auth-screen-main-div'>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
          <img style={{ height: '110px', width: '135px' }} src={CitydealsLogo} />
        </div>
        <p className='heading head-center'>
          {path === allPaths?.BU_LOGIN ? selectedLanguage?.BusinessLogin : selectedLanguage?.Login}
        </p>
        <p style={{ textAlign: 'center', color: 'grey' }}>{selectedLanguage?.WelcomeBack}</p>
        <Form
          name='form'
          onFinish={onFinish}
          layout={'vertical'}
          requiredMark={false}
        >

          <div className='form-two-input-flex'>
            <div className='form-two-input-flex-inner-input'>
              <Form.Item
                name='email'
                label={selectedLanguage?.Email}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: selectedLanguage?.PleaseInputYourEmail,
                  },
                  {
                    type: 'email',
                    message: selectedLanguage?.EmailIsNotValid,
                  },
                ]}
              >
                <Input className='form-input-new-style' placeholder={selectedLanguage?.InputYourEmailHere} />
              </Form.Item>
            </div>
            <div className='form-two-input-flex-inner-input'>
              <Form.Item
                name='password'
                label={selectedLanguage?.Password}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: selectedLanguage?.PleaseInputYourPassword,
                  },
                  {
                    min: 6,
                    message: selectedLanguage?.PasswordMustBeAtLeastCharacters,
                  },
                ]}
              >
                <Input.Password
                  className='form-input-new-style'
                  placeholder={selectedLanguage?.InputYourPasswordHere}
                />
              </Form.Item>
            </div>
          </div>
          {path === allPaths?.BU_LOGIN ? (
            <Form.Item>
              <Button
                type='primary'
                className='addproduct-text form-input-new-style'
                style={{ height: '45px', width: '99%', marginTop: '10px' }}
                htmlType='submit'
                loading={loading}
              >
                {selectedLanguage?.BusinessLogin}
              </Button>
            </Form.Item>
          ) : (
            <Form.Item>
              <Button
                type='primary'
                className='addproduct-text form-input-new-style'
                style={{ height: '45px', width: '99%', marginTop: '10px' }}
                htmlType='submit'
                loading={loading}
              >
                {selectedLanguage?.Login}
              </Button>
            </Form.Item>
          )}
        </Form>
        <div style={{ textAlign: 'center' }}>
          <p>
            {selectedLanguage?.DonTaveAnAccount}&nbsp;
            {path === allPaths?.BU_LOGIN ? <span>
              <Link to={allPaths?.BU_SIGNUP}>{selectedLanguage?.login_BusinessSignUp}</Link>
              <br />
              <Link to={allPaths?.BU_FORGOT}>{selectedLanguage?.login_ForgotPassword}</Link>
            </span> : <span>
              <Link to={allPaths.SIGNUP}>{selectedLanguage?.login_SignUp}</Link>
              <br />
              <Link to={allPaths?.FORGOT}>{selectedLanguage?.login_ForgotPassword}</Link>
            </span>}
          </p>
        </div >
      </div >
    </div >
  )
}

export default Login
